import { Box, MenuItem, Select } from "@mui/material";
import { styled } from "@mui/styles";
import React from "react";
import VSNFormControl from "./VSNFormControl";
import VSNTypography from "./VSNTypography";

const StyledSelect = styled(Select)(({ theme }) => ({
  "& .MuiSelect-select": {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: "23px",
    color: "#202024",
    padding: "8px 0",
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
    "&:focus": {
      background: "transparent",
    },
  },
  "&.MuiInputBase-root": {
    "&::before": {
      borderBottom: "1px solid #CBCBCF !important",
    },
  },
  "& .MuiSelect-icon": {
    top: "inherit",
    "& path": {
      stroke: "var(--primary)",
    },
  },
  "& .MuiPaper-root": {
    maxHeight: 300,
  },
  "& .MuiPopover-root": {
    "& .MuiPaper-root": {
      position: "static",
    },
  },
}));

// const VSNSelect = (props) => {
//   const {
//     value = 0,
//     options,
//     label,
//     onChange,
//     elementId,
//     name,
//     fullWidth,
//     variant,
//     classes,
//     placeHolder,
//     disabled = false,
//     readOnly,
//     formControlSx,
//     ...rest
//   } = props;
//   return (
//     <VSNFormControl fullWidth={fullWidth} sx={formControlSx}>
//       <StyledSelect
//         MenuProps={{
//           PopoverClasses: { root: classes?.popover },
//         }}
//         labelId={`${name}-${elementId}`}
//         id={`${name}-${elementId}`}
//         value={value}
//         name={name}
//         onChange={onChange}
//         variant={variant}
//         fullWidth={fullWidth}
//         disabled={disabled || readOnly}
//         renderValue={(selected) => {
//           if (selected === 0) {
//             return (
//               <span style={{ color: "rgb(198 198 205)", fontWeight: 400 }}>
//                 {placeHolder}
//               </span>
//             );
//           }
//           return options?.find((item) => item.value === selected)?.key;
//         }}
//         {...rest}
//       >
//         {options?.map(({ value, key }, index) => {
//           return (
//             <MenuItem value={value} key={index}>
//               {key}
//             </MenuItem>
//           );
//         })}
//       </StyledSelect>
//     </VSNFormControl>
//   );
// };

// export default VSNSelect;

const VSNSelect = (props) => {
  const {
    value = 0,
    options,
    label,
    onChange,
    elementId,
    name,
    fullWidth,
    variant,
    classes,
    placeHolder,
    disabled = false,
    readOnly,
    formControlSx,
    ...rest
  } = props;
  return (
    <VSNFormControl fullWidth={fullWidth} sx={formControlSx}>
      <StyledSelect
        MenuProps={{
          PopoverClasses: { root: classes?.popover },
        }}
        labelId={`${name}-${elementId}`}
        id={`${name}-${elementId}`}
        value={value}
        name={name}
        onChange={onChange}
        variant={variant}
        fullWidth={fullWidth}
        disabled={disabled || readOnly}
        renderValue={(selected) => {
          if (selected === 0 || selected === "") {
            return (
              <span style={{ color: "rgb(198 198 205)", fontWeight: 400 }}>
                {placeHolder}
              </span>
            );
          }
          const selectedItem = options?.find((item) => item.value === selected);
          return selectedItem?.key || "";
        }}
        {...rest}
      >
        {options?.map(({ value, key, isSubOption }, index) => (
          <MenuItem value={value} key={index}>
            <VSNTypography
              sx={{
                pl: isSubOption ? 4 : 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                color: isSubOption ? "text.secondary" : "text.primary",
                fontWeight: 500,
              }}
            >
              {key}
            </VSNTypography>
          </MenuItem>
        ))}
        {/* this code for disable previous select option from dropdown */}
        {/* {options?.map(({ value, key, isSubOption, disabled }, index) => (
          <MenuItem value={value} key={index} disabled={disabled}>
            <VSNTypography
              sx={{
                pl: isSubOption ? 4 : 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                color: isSubOption ? "text.secondary" : "text.primary",
                fontWeight: 500,
              }}
            >
              {key}
            </VSNTypography>
          </MenuItem>
        ))} */}
      </StyledSelect>
    </VSNFormControl>
  );
};

export default VSNSelect;
